// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/notifications_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * Move
 *
 * @generated from message protogen.NotificationRegistrationRequest
 */
export class NotificationRegistrationRequest extends Message<NotificationRegistrationRequest> {
  /**
   * @generated from field: string platform = 1;
   */
  platform = "";

  /**
   * @generated from field: string subscription = 2;
   */
  subscription = "";

  constructor(data?: PartialMessage<NotificationRegistrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.NotificationRegistrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "platform", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subscription", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationRegistrationRequest {
    return new NotificationRegistrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationRegistrationRequest {
    return new NotificationRegistrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationRegistrationRequest {
    return new NotificationRegistrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationRegistrationRequest | PlainMessage<NotificationRegistrationRequest> | undefined, b: NotificationRegistrationRequest | PlainMessage<NotificationRegistrationRequest> | undefined): boolean {
    return proto3.util.equals(NotificationRegistrationRequest, a, b);
  }
}

/**
 * @generated from message protogen.NotificationRegistrationResponse
 */
export class NotificationRegistrationResponse extends Message<NotificationRegistrationResponse> {
  constructor(data?: PartialMessage<NotificationRegistrationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.NotificationRegistrationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationRegistrationResponse {
    return new NotificationRegistrationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationRegistrationResponse {
    return new NotificationRegistrationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationRegistrationResponse {
    return new NotificationRegistrationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationRegistrationResponse | PlainMessage<NotificationRegistrationResponse> | undefined, b: NotificationRegistrationResponse | PlainMessage<NotificationRegistrationResponse> | undefined): boolean {
    return proto3.util.equals(NotificationRegistrationResponse, a, b);
  }
}

